<template>
    <div class="join-view">
        <van-nav-bar
            title="聊天服务列表"
            left-text="退出"
            right-text="刷新"
            left-arrow
            @click-left="onLoginOut"
            @click-right="onRefresh"
        />
        <van-tree-select
            v-model:main-active-index="activeIndex"
            height="55vw"
            :items="items"
        >
            <template #content>
                <div v-for="(item, index) in dataList" :key="item.id" class="user-container">
                    <div class="user-info"  v-if="activeIndex === index">
                        <div>头像:
                            <img class="user-avatar" :src="item.avatar" :alt="item.nickname" >
                        </div>
                        <br>
                        <div>编号 : <span>{{ item.id }}</span></div>
                        <br>
                        <div>姓名 : <span>{{ item.nickname }}</span></div>
                        <br>
                        <div>年龄 : <span>{{ item.age }}岁</span></div>
                        <br>
                        <div>性别 : <span>{{ getSexName(item.sex) }}</span></div>
                        <br>
                        <div>身高 : <span>{{ item.height }}cm</span></div>
                        <br>
                        <div>籍贯 : <span>{{ item.household_reg_province }} | {{ item.household_reg_city }} | {{ item.household_reg_county }}</span></div>
                        <br>
                        <div>学历 : <span>{{ getEducationName(item.education) }}</span></div>
                        <br>
                        <div>婚姻 : <span>{{ getMarriageName(item.marriage) }}</span></div>
                        <br>
                        <div>职业 : <span>{{ item.job }}</span></div>
                        <br>
                        <div>月收入 : <span>{{ getSalaryName(item.salary) }}</span></div>
                        <br>
                        <div>个人独白 : <span>{{ item.bio }}</span></div>
                        <br>
                        <div>备注 : <span>{{ item.remark }}</span></div>
                        <br>

                        <van-space>
                            <van-button type="primary" @click="showRemark(item.id,item.remark)">设置备注</van-button>
                            <van-button type="success" @click="goChat(item.id)">前往聊天</van-button>
                        </van-space>
                    </div>
                </div>

            </template>
        </van-tree-select>
        <van-popup v-model:show="remarkShow" :style="{ width: '400px' }">
            <van-field
                label="备注"
                label-width="35px"
                size="normal"
                colon
                autosize
                autofocus
                name="remark"
                v-model="remarkValue"
                type="textarea"
                maxlength="50"
                placeholder="请输入备注"
                show-word-limit
            />
            <div style="margin: 16px;">
                <van-button round block type="primary" @click="setRemark">
                    提交
                </van-button>
            </div>
        </van-popup>
    </div>

</template>
<script>

import ayzAjax from "@/plugins/axios";
import {showFailToast, showSuccessToast} from "vant";
import {getEducationName, getMarriageName, getSalaryName, getSexName} from "@/assets/js/common";

export default {
    name: "JoinView",
    data: function () {
        return {
            remarkShow:false,
            remarkValue:'',
            activeIndex:0,
            items: [{ text: '无数据' }],
            chatLoginInfo: null,
            dataList: [],
            thisUserId: null,
        }
    },
    created() {
        this.chatLoginInfo = JSON.parse(localStorage.getItem('chatLoginInfo'));
        if (this.chatLoginInfo === null){
            this.$router.push({ path: '/chat/login'});
        }else{
            this.getClientList();
        }
        // console.log(this.chatLoginInfo.employee_name);
    },
    methods: {
        getMarriageName,
        getEducationName,
        getSexName,
        getSalaryName,
        goChat(userId){
            // console.log(userId);
            let chatUrl = process.env.VUE_APP_CHAT_URL + '?id=' + userId + '&token=' + this.chatLoginInfo.jwt_info.access_token;
            // console.log(chatUrl)
            window.open(chatUrl, '_blank');
        },
        showRemark(id,remark){
            this.remarkShow = !this.remarkShow;
            this.remarkValue = remark;
            this.thisUserId = id;
        },
        setRemark(){
            // console.log(this.remarkValue);
            let fromData = {};
            fromData['client_user_id'] = this.thisUserId;
            fromData['remark'] = this.remarkValue;
            ayzAjax.post('/chat/remark',fromData,{
                headers: {
                    'Authorization': 'Bearer ' + this.chatLoginInfo.jwt_info.access_token,
                }
            }).then((response) => {
                if(response.data.code !== 200){
                    showFailToast('提交失败,请稍后再试')
                    return false;
                }
                this.remarkShow = false;
                this.getClientList();
            })
        },
        onLoginOut(){
            localStorage.setItem('chatLoginInfo', null);
            this.$router.push({ path: '/chat/login'});
        },
        onRefresh(){
            this.getClientList('refresh');
        },
        getClientList(type){
            try {
                let url = '/chat/get_client_list?employee_name=' + this.chatLoginInfo.employee_info.employee_name;
                ayzAjax.get(url,{
                    headers: {
                        'Authorization': 'Bearer ' + this.chatLoginInfo.jwt_info.access_token,
                    }
                }).then((response) => {
                    if(response.data.code !== 200){
                        localStorage.setItem('chatLoginInfo', null);
                        this.$router.push({ path: '/chat/login'});
                        return false;
                    }
                    if (type === 'refresh'){
                        showSuccessToast('已刷新')
                    }
                    this.dataList = response.data.data.client_list;
                    this.items = [];
                    this.dataList.map(item => {
                        // console.log(item);
                        this.items.push({'text':item.nickname})
                    })

                })
            }catch(err) {
                console.log(err);
                showFailToast('请求超时,请稍后再试')
            }
        },

    }
}
</script>

<style scoped lang="scss" >
.join-view{
    text-align: left;
    margin-left: auto;
    margin-right: auto;
    background: #F7F8FA;
    width: 500px;
    .user-container{
        margin: 10px;
        .user-info{
            height: 500px;
            .user-avatar{
                border-radius: 5px;
                width: 250px;
                height: 250px;
            }
            span{
                font-size: 14px;
                color:#666666;
            }
        }
    }
}
.form-box{
    width: 100%;
}
</style>

